import React, {Component} from 'react';
import {connect} from "react-redux";
import {NavBar} from 'antd-mobile';
import './style.less';
const empty = require('../../../common/image/v2/empty.png');

@connect(
    state => ({userInfo: state.userInfo})
)
export default class Empty extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {}


   
    render() {
        return (
            <div className='emptypage'>
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                ></NavBar>
                <img className='empty' src={empty}></img>
                <div className='text'>该功能正在维护中，敬请期待~</div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/Empty/index.js